import { CUSTOMER_ORIGIN, ORIGIN } from "@zhihaoscm/meta";
import { type CaptchaLoginForm, type MeVo, type PcAccountLoginForm } from "@zhihaoscm/entity";
import { BaseService } from "./baseService";
import httpRequest from "./index";
import type { Session } from "../../../../common/types/login";

export class LoginService extends BaseService<any, any, any, any> {
    public async accountLogin(params: PcAccountLoginForm): Promise<{ data: Session; message?: "" }> {
        return await this.service.post(`${this.path}/pc/account`, params);
    }
    public async login(params: CaptchaLoginForm) {
        return await this.service.post(`${this.path}/pc`, params);
    }

    public async createAccount(params: any) {
        const { data } = await this.service.post(`/create`, params);
        return data;
    }

    public async getMe(): Promise<MeVo> {
        const { data } = await this.service.get(`${this.path}/me`);
        return data;
    }

    public async logout() {
        const { data } = await this.service.get("/logout");
        return data;
    }

    // 切换代理账号 /login/switch/proxy
    public async loginSwitchProxy(proxyAccountId: number) {
        // 区分端 PC只有链云
        const appType = CUSTOMER_ORIGIN.CUSTOMER.code;
        const { data } = await this.service.put(
            `${this.path}/switch/proxy?proxyAccountId=${proxyAccountId}&origin=${ORIGIN.PC.code}&role=${appType}`
        );
        return data;
    }
}

export const loginService = new LoginService("/login", httpRequest);
